window.FSAcademyCallbackManager = {};

class FSAcademyNativeAppAdapter {
  private id = 1;

  isRunningInAndroidApp() {
    return !!window.FSAcademyAndroidBridge;
  }

  isNotificationPermissionGranted() {
    return window.FSAcademyAndroidBridge?.isNotificationPermissionGranted() ?? false;
  }

  readyForMessages() {
    return window.FSAcademyAndroidBridge?.readyForMessages();
  }

  requestNotificationToken(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      if (!window.FSAcademyAndroidBridge) {
        resolve(null);
        return;
      }

      const callbackName = this.registerCallback((value) => {
        clearTimeout(timeout);
        delete window.FSAcademyCallbackManager[callbackName];
        resolve(value);
      });

      const timeout = setTimeout(() => {
        delete window.FSAcademyCallbackManager[callbackName];
        reject(new Error("Timeout"));
      }, 30000);

      window.FSAcademyAndroidBridge.requestNotificationPermission(callbackName);
    });
  }

  getScannerMimeType() {
    return this.isRunningInAndroidApp() ? SCANNER_MIME_TYPE : undefined;
  }

  private registerCallback(resolve: (value: string) => void) {
    const callbackName = `callback_${this.id++}`;
    window.FSAcademyCallbackManager[callbackName] = resolve;
    return `window.FSAcademyCallbackManager.${callbackName}`;
  }
}

export const nativeAppAdapter = new FSAcademyNativeAppAdapter();
export const SCANNER_MIME_TYPE = "application/vnd.bg.fsacademy.scanner";
